import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/useAuthStore';

interface Props {
  permission: string;
  /** Sensible Berechtigung (z.B. Medizin, Art. 9 DSGVO) – Nicht-Admins brauchen sie explizit. */
  sensitive?: boolean;
}

/**
 * Erlaubt Zugriff nur, wenn der eingeloggte User die Berechtigung besitzt.
 * Normale Rechte: Admins werden durchgelassen (Superuser-Bypass).
 * Sensible Rechte (`sensitive`): Admins passieren (seit 2026-07-15), sonst explizite Zuweisung nötig.
 * Ohne Berechtigung: Weiterleitung auf /no-access.
 */
export function RequirePermission({ permission, sensitive }: Props) {
  const allowed = useAuthStore((s) =>
    sensitive ? s.hasSensitivePermission(permission) : s.hasPermission(permission),
  );

  if (!allowed) {
    return <Navigate to="/no-access" replace />;
  }

  return <Outlet />;
}
